<script lang="ts">
	import {
		fetchingMarkets,
		marketSortDirection,
		marketSortKey,
		markets,
		sortedMarkets
	} from '$lib/home/store';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { filterMarketsBasedOnSearch } from '$lib/util/util';
	import { walletConnected } from '$lib/wallet/store';
	import { goto } from '$app/navigation';
	import EachMarket from './EachMarket.svelte';
	import MarketSortHeader from './MarketHeader.svelte';
	import MarketSearch from '$lib/home/topInfoSection/MarketSearch.svelte';
	import MarketTopSection from './MarketTopSection.svelte';

	let searchText: string = '';

	$: filteredMarkets = filterMarketsBasedOnSearch($sortedMarkets, searchText);
</script>

<GradientBorder
	gradient="bg-fx-gradient-6"
	paddingClass="p-px"
	borderRadius="rounded-xl squircle-xl"
	outerClassList="w-full h-fit"
	innerClassList="flex justify-center items-center bg-fx-black w-full"
>
	<div
		class="p-4 sm:p-6 flex flex-col items-start w-full rounded-xl squircle-xl bg-fx-gradient-8-40"
	>
		<div class="w-full flex flex-row justify-between items-center">
			<div class="font-semibold text-2lg">
				<span class="text-fx-gradient-5"> Markets </span>
			</div>
		</div>

		<MarketTopSection />
		<div class="border-t border-t-fx-grey-600 w-full my-4" />

		<div class="text-fx-white my-2 gap-2 flex">
			<MarketSearch bind:searchText gradientStyle="bg-fx-grey-300 w-[300px]" />

			<button
				class="text-fx-grey-200 text-base font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
				class:text-fx-white={$marketSortKey == 'volume24h' && $marketSortDirection == 'Descending'}
				on:click={() => {
					$marketSortKey = 'volume24h';
					$marketSortDirection = 'Descending';
				}}>Trending</button
			>
			<button
				class="text-fx-grey-200 text-base font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
				class:text-fx-white={$marketSortKey == 'change24hPercentage' &&
					$marketSortDirection == 'Ascending'}
				on:click={() => {
					$marketSortKey = 'change24hPercentage';
					$marketSortDirection = 'Ascending';
				}}>Top Losers</button
			>
			<button
				class="text-fx-grey-200 text-base font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
				class:text-fx-white={$marketSortKey == 'change24hPercentage' &&
					$marketSortDirection == 'Descending'}
				on:click={() => {
					$marketSortKey = 'change24hPercentage';
					$marketSortDirection = 'Descending';
				}}>Top Gainers</button
			>
			<button
				class="text-fx-grey-200 text-base font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
				class:text-fx-white={$marketSortKey == 'fundingRatePercentageLast1h' &&
					$marketSortDirection == 'Descending'}
				on:click={() => {
					$marketSortKey = 'fundingRatePercentageLast1h';
					$marketSortDirection = 'Descending';
				}}>Funding Rate</button
			>
			<button
				class="text-fx-grey-200 text-base font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
				on:click={() => goto('/markets-more')}>More Details</button
			>
		</div>
		<div class="border-t border-t-fx-grey-600 w-full my-4" />

		<div class="hidden sm:grid grid-cols-6 w-full">
			<div class="text-fx-grey-300 text-xs">Market</div>
			<div class="text-fx-grey-300 text-xs text-center">Current Price</div>

			<MarketSortHeader header="24h Change" sortKey="change24hPercentage" />
			<MarketSortHeader header="24h Volume" sortKey="volume24h" />
			<MarketSortHeader header="1h Funding Rate" sortKey="fundingRatePercentageLast1h" />
			<MarketSortHeader header="Open Interest" sortKey="openInterest" />
		</div>

		<div class="hidden sm:border-t border-t-fx-grey-600 w-full my-5" />
		{#if !$markets && !$fetchingMarkets && $walletConnected}
			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />

			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />

			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />
		{:else if $fetchingMarkets}
			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />

			<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />
		{:else if $markets && !$fetchingMarkets && $sortedMarkets}
			{#each filteredMarkets as market}
				<EachMarket {market} />
			{/each}
		{/if}
	</div>
</GradientBorder>
